module.exports = __webpack_public_path__ + "static/media/onestop_img2.9800ee82.jpg";